import React from "react";
import { BiStoreAlt } from "react-icons/bi";
import { GrAnnounce } from "react-icons/gr";
import { Tag, Tooltip } from "antd";
import Button from "./Button";
import dayjs from "dayjs";

const OutletCard = ({
  businessName,
  stampCodes = [],
  address,
  created,
  onAddStampDevice,
  onEdit,
  onDelete,
  announce,
  showAddStampDevice = false,
  onEditLabel,
  showDelete = true,
}) => {
  return (
    <div className="outlet-card">
      {announce ? (
        <GrAnnounce className="outlet-card-icon" size={48} />
      ) : (
        <BiStoreAlt className="outlet-card-icon" size={48} />
      )}

      <div className="outlet-card-content">
        <h4 className="active">{businessName}</h4>

        {address && (
          <p>
            📍 {address.house_number}, {address.street_name}, {address.town}{" "}
            {address.postal_code}
          </p>
        )}

        <p>
          🗓️ Created:{" "}
          <span className="active">
            {dayjs(created).format("MMMM D, YYYY")}
          </span>
        </p>

        {stampCodes?.length > 0 && (
          <div className="outlet-stamps">
            <span>Stamps:</span>
            <div className="outlet-stamps-tags">
              {stampCodes.map((code, index) => (
                <Tooltip title={code} key={index}>
                  <Tag color="#f11e69">{code}</Tag>
                </Tooltip>
              ))}
            </div>
          </div>
        )}
      </div>

      <div className="outlet-card-btns">
        {showAddStampDevice && (
          <Button
            className="outlet-card-btn"
            onClick={() => onAddStampDevice()}
          >
            Add Stamp Code
          </Button>
        )}
        {/* <Button className="outlet-card-btn" onClick={onEdit}>
          {onEditLabel || "Add Satmp Code"}
        </Button> */}
        {showDelete && (
          <Button
            className="outlet-card-btn"
            variant="secondary"
            onClick={onDelete}
          >
            Delete
          </Button>
        )}
      </div>
    </div>
  );
};

export default OutletCard;
